import { responseHero } from "../../../../utils/axiosInterceptor";
import { toast } from "react-toastify";
import { FixDepositRegister } from "../../../../models/fixdepositregister.model";
import { Group } from "../../../../models/group.model";

type RemoveModalProps = {
    title: string;
    group: Group | undefined;
    showModal: boolean;
    closeModal: () => void;
    handleStateChange: () => void;
    row: FixDepositRegister | undefined;
}

const RemoveFixDepositModal = ({ title, showModal, closeModal, row, group, handleStateChange }: RemoveModalProps) => {

    const removeRow = async (selectedRow: FixDepositRegister | undefined) => {
        if (!selectedRow || !group) return;
        
        // Igazítva a fix deposit végponthoz
        await responseHero.delete(`${process.env.REACT_APP_API_URL}/fdr/${selectedRow.id}`)
        .then(() => {
            closeModal();
            handleStateChange();
            toast.success("Sor sikeresen törölve!");
        })
        .catch(error => {
            console.error(error);
            closeModal();
            toast.error("Hiba a sor törlése közben!");
        });
    };

    return (
        <>
            {(showModal && row) && (
                <>
                <div className="flex justify-center items-center overflow-x-hidden overflow-y-auto fixed inset-0 z-50 outline-none focus:outline-none">
                    <div className="relative w-auto my-6 mx-auto max-w-3xl">
                        <div className="border-0 rounded-lg shadow-lg relative flex flex-col w-full bg-white outline-none focus:outline-none">
                            
                            <div className="flex items-start justify-between p-5 border-b border-solid border-gray-300 rounded-t">
                                <h3 className="text-3xl text-dark-blue font-semibold">{title}</h3>
                            </div>
                            
                            <div className="relative p-6 flex-auto">
                                <p className="text-dark-blue">Biztos vagy benne, hogy törlöd ezt a sort?</p>
                                <p className="text-brown text-sm mt-2">
                                    Ügyfél: <b>{row?.user?.name}</b> | Befektetés: <b>{row.invested} EUR</b>
                                </p>
                                {row.contractStartDate && (
                                    <p className="text-gray-500 text-xs mt-1">
                                        Szerződés kezdete: {row.contractStartDate.toString().split('T')[0]}
                                    </p>
                                )}
                            </div>
                            
                            <div className="flex items-center justify-end p-6 border-t border-solid border-gray-200 rounded-b">
                                <button
                                    className="text-red-500 font-bold uppercase px-6 py-2 text-sm outline-none mr-1 mb-1"
                                    type="button"
                                    onClick={closeModal}
                                >
                                    Mégse
                                </button>
                                <button
                                    className="text-cream bg-dark-blue font-bold uppercase text-sm px-6 py-3 rounded shadow hover:shadow-lg outline-none mr-1 mb-1"
                                    type="button"
                                    onClick={() => removeRow(row)}
                                >
                                    Törlés
                                </button>
                            </div>

                        </div>
                    </div>
                </div>
                <div className="fixed inset-0 bg-black bg-opacity-50 backdrop-filter backdrop-blur-sm z-40"></div>
                </>
            )}
        </>
    );
};

export default RemoveFixDepositModal;